// extracted by mini-css-extract-plugin
export default {"link":"Categories_link__WAwi+"};